import { OnboardingProTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useTranslation } from '@frontend/i18n';
import { type TaskContentProps } from '@frontend/product-onboarding';
import { useProOnboardingProgress } from '../hooks/use-pro-onboarding-progress';
import { useProTaskActions } from '../task-actions/use-pro-task-actions';
import { OnboardingTaskContentView } from './onboarding-task-content-view';

export function ProProductTaskContent(props: TaskContentProps) {
  const { t } = useTranslation('call-intel-onboarding');

  const actions = useProTaskActions({ onClose: props.onClose });
  const { completedGroups } = useProOnboardingProgress();

  return (
    <OnboardingTaskContentView<OnboardingProTask>
      {...props}
      title={t('Get Started with Call Intelligence')}
      completedGroups={completedGroups}
      actions={actions}
    />
  );
}
